<div [@routerTransition] class="height-100pe">
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="row height-100pe">
    <div class="col-md-12 ">
      <div class="card my-profile-form margin-top-15px top-link">
        <div class="card-header wh-header padding-bottom-6px">
          <div class="row">
            <div class="col-md-3">
             New Expense Voucher
            </div>
            <div class="col-md-9 float-right">
              <button class="btn actions-btn-prime float-right font-size-13px margin-right-5px" (click)="onSubmitExpensenew()">Submit</button>
            </div>

          </div>

        </div>
        <div class="card-body padding-top-0px margin-left-0px">

          <div class="row font-size-14 margin-top-10">
            <div class="col-md-4 text-align-right padding-left-0px">
              <label class="margin-bottom-0px">Facility </label>
            </div>
            <div class="col-md-2  padding-left-10px my-profile-form">

              <div class="form-group margin-bottom-0px">
                <CustomDataByRequestType RequestedType="FacilityList" ActorCode={{ActorCode}}
                                         (keyChange)="Roleassign($event)"
                                         [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode"
                                         required>
                </CustomDataByRequestType>
                <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                <!--<h4 class=" margin-bottom-0px margin-top-3px">4116</h4>-->


              </div>


            </div>

          </div>


          <div class="row font-size-14 margin-top-10">
            <div class="col-md-4 text-align-right padding-left-0px">
              <label class="margin-bottom-0px">Employee</label>
            </div>
            <div class="col-md-2  padding-left-10px my-profile-form">

              <div class="form-group margin-bottom-0px">
                <CustomDataByRequestType RequestedType="EmployeeActorCodeByFacility" ActorCode={{ActorCode}} FacilityCode={{FacilityCode}}
                                         (keyChange)="Roleassignemp($event)"
                                         [(ngModel)]="SelectedEmployeeCode" name="SelectedEmployeeCode"
                                         required>
                </CustomDataByRequestType>
                <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->


              </div>


            </div>

          </div>
          <div class="row font-size-14 margin-top-10 my-profile-form">
            <div class="col-md-4 text-align-right padding-left-0px">
              <label class="margin-bottom-0px margin-top-0px">Date </label>
            </div>
            <div class="col-md-2  padding-left-10px form-group margin-bottom-0px">

              <div class="date-form">
                <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                       name="dp1" [(ngModel)]="Date" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                <!--<small class="form-text text-danger"
  *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->
                <a (click)="d1.toggle()" class="nav-link-hand">
                  <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                </a>

              </div>


            </div>

          </div>
          <div class="row font-size-14 margin-top-10">
            <div class="col-md-4 text-align-right padding-left-0px">
              <label class="margin-bottom-0px">Claim Status</label>
            </div>
            <div class="col-md-2  padding-left-10px my-profile-form">

              <div class="form-group margin-bottom-0px">
                <CodeTypeValue CodeType="Claim"  id="CurrentSaveExpenseVoucherRequest.ClaimStatus"
        [(ngModel)]="CurrentSaveExpenseVoucherRequest.ClaimStatus" SelectedValue="CurrentSaveExpenseVoucherRequest.ClaimStatus"
        name="CurrentSaveExpenseVoucherRequest.ClaimStatus"></CodeTypeValue>
                <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->


              </div>


            </div>

          </div>
          <div class="row font-size-14 margin-top-10">
            <div class="col-md-4 text-align-right padding-left-0px">
              <label class="margin-bottom-0px">Authorize Status</label>
            </div>
            <div class="col-md-2  padding-left-10px my-profile-form">

              <div class="form-group margin-bottom-0px">
                <CodeTypeValue CodeType="APSTA" id="CurrentSaveExpenseVoucherRequest.AuthorizeStatus"
        [(ngModel)]="CurrentSaveExpenseVoucherRequest.AuthorizeStatus" SelectedValue="CurrentSaveExpenseVoucherRequest.AuthorizeStatus"
        name="CurrentSaveExpenseVoucherRequest.AuthorizeStatus"></CodeTypeValue>
                <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->


              </div>


            </div>

          </div>
          <div class="row font-size-14 margin-top-10">
            <div class="col-md-4 text-align-right padding-left-0px">
              <label class="margin-bottom-0px">ApprovedBy</label>
            </div>
            <div class="col-md-2  padding-left-10px my-profile-form">

              <div class="form-group margin-bottom-0px">
                <CustomDataByRequestType RequestedType="EmployeeActorCodeByFacility" ActorCode={{ActorCode}} FacilityCode={{FacilityCode}}
                                         (keyChange)="RoleassignApp($event)"
                                         [(ngModel)]="SelectedAppCode" name="SelectedAppCode"
                                         required>
                </CustomDataByRequestType>
                <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->


              </div>


            </div>

          </div>
          <div class="row font-size-14 margin-top-10">
            <div class="col-md-4 text-align-right padding-left-0px">
              <label class="margin-bottom-0px">Payment Type</label>
            </div>
            <div class="col-md-2  padding-left-10px my-profile-form">

              <div class="form-group margin-bottom-0px">
                <CodeTypeValue CodeType="PYTMD" id="CurrentSaveExpenseVoucherRequest.PaymentType"
        [(ngModel)]="CurrentSaveExpenseVoucherRequest.PaymentType" SelectedValue="CurrentSaveExpenseVoucherRequest.PaymentType"
        name="CurrentSaveExpenseVoucherRequest.PaymentType"></CodeTypeValue>
                <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->


              </div>


            </div>

          </div>
          <div class="row font-size-14 margin-top-10">
            <div class="col-md-4 text-align-right padding-left-0px">
              <label class="margin-bottom-0px margin-top-5px">Purpose </label>
            </div>
            <div class="col-md-3  padding-left-10px my-profile-form">

              <div class="form-group margin-bottom-0px">
                <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                <textarea class="form-control3 size-2" rows="2" placeholder="Purpose"
               name="CurrentSaveExpenseVoucherRequest.Purpose" [(ngModel)]="CurrentSaveExpenseVoucherRequest.Purpose" required minlength="1" maxlength="100"
                                                      #addconcerns_text="ngModel"></textarea>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>


              </div>


            </div>

          </div>
          <div class="row font-size-14 margin-top-10">
            <div class="col-md-4 text-align-right padding-left-0px">
              <label class="margin-bottom-0px margin-top-5px">Remarks </label>
            </div>
            <div class="col-md-3  padding-left-10px my-profile-form">

              <div class="form-group margin-bottom-0px">
                <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                <textarea class="form-control3 size-2" rows="2" placeholder="Remarks"
                          name="CurrentSaveExpenseVoucherRequest.Remarks" [(ngModel)]="CurrentSaveExpenseVoucherRequest.Remarks" required minlength="1" maxlength="100"
                          #addconcerns_text1="ngModel"></textarea>
                <small class="form-text text-danger"
                       *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>


              </div>


            </div>

          </div>
          <div class="row font-size-14 margin-top-10">
            <div class="col-md-5 text-align-right padding-right-0px">

            

            </div>


          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="accordion" id="accordionExample">
                <div class="card margin-bottom-5px">
                  <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                    <div class="row margin-right-0px">
                      <div class="col-md-4">
                        <h5 class="mb-0 height-24px">
                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Expenses Details
                          </button>
                        </h5>
                      </div>
                      <div class="col-md-8 text-align-right">
                        <button type="button" (click)="AddExpenses()" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px">
                          <i class="fas fa-plus "></i> Add
                        </button>
                        <!--<button class="btn actions-btn-prime float-right font-size-13px margin-right-5px">Approve</button>-->

                      </div>
                    </div>


                  </div>

                  <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                      <!--<div class="row font-size-14 margin-top-10">
            <div class="col-md-4 text-align-right padding-left-0px">
              <label class="margin-bottom-0px">Total Amount </label>
            </div>:
            <div class="col-md-7  padding-left-10px my-profile-form">

              <div class="form-group margin-bottom-0px">


                <h4 class="margin-bottom-0px  margin-top-3px">4116</h4>


              </div>


            </div>

          </div>-->

                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-component">
                            <div class="table-responsive overflow-x">


                              <table class="table table-striped  table-fixed"
                                     cols="auto,2*,*,*,*,*,*,*">

                                <thead class="">
                                  <tr>

                                    <th class="padding-top-4px padding-bottom-4px th-sticky">
                                      Item
                                    </th>



                                    <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-0px">
                                      Description
                                    </th>
                                    <th class="padding-top-4px padding-bottom-4px th-sticky">
                                      ItemAmount
                                    </th>







                                  </tr>
                                </thead>

                                <tbody class="table-body">
                                  <tr *ngFor="let l of ItemsSelected">


                                    <td class="padding-top-5px padding-bottom-5px">
                                      {{l.ItemName}}
                                    </td>
                                    <td class="padding-top-5px padding-bottom-5px">{{l.Description}}</td>

                                    <td class="padding-top-5px padding-bottom-5px padding-right-0px">
                                      <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
  [(ngModel)]="l.quantity"
  maxlength="2" required>-->
                                      {{l.ItemAmount}}
                                    </td>



                                  </tr>
                                </tbody>



                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          

        </div>
      </div>
    </div>

  </div>


</div>


